<template>
    <rkm-modal
        ref="RkmModal"
        title="Atenção Básica"
        extraLarge
        persistent
    >

        <Tabs
            v-if="loaded"
            ref="Tabs"
            :data="data"
            :pacienteId="pacienteId"
            @saveAtendimentoIndividual="saveAtendimentoIndividual"
            @handleAtendimentoIndividual="handleAtendimentoIndividual"
            @saveAtendimentoOdontologico="saveAtendimentoOdontologico"
            @handleAtendimentoOdontologico="handleAtendimentoOdontologico"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                v-if="atendimentoIndividual || atendimentoOdontologico"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components
import Tabs from './Tabs'

// Mixins.
import {error, repository, stringCase, object} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Enums.
import procedimento from '@/enums/atencao-basica/atendimento-odontologico/procedimento'

export default {
    components: {
        Tabs,
    },
    computed: {
        validations() {
            return {
                motivo: {
                    required: true,
                    max: 500,
                },
            }
        },
    },
    created() {
        this.repositories = {
            fechamento: this.getConectaSusRepository('ambulatorio.fechamentoConsulta'),
        }
    },
    data: () => ({
        id: null,
        tipo: null,
        loaded: false,
        data: {
            model: null,
            form: null,
        },
        equipes: [],
        atendimentoIndividual: false,
        atendimentoOdontologico: false,
        dadosAtendimentoIndividual: null,
        dadosAtendimentoOdontologico: null,
        enums: {
            procedimento,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(model, form) {

            this.loaded = false

            this.id = model.agendamentoId ? model.agendamentoId : model.atendimentoId
            this.tipo = model.agendamentoId ? 'agendamento' : 'demandaEspontanea'
            this.pacienteId = model.pacienteId
            this.data.form = form
            this.data.model = model

            const request = {
                usuarioId: model.usuarioId,
                infraestruturaId: model.infraestruturaId,
                ocupacaoId: model.ocupacaoId,
                pacienteId: model.pacienteId,
                data: model.data,
            }

            this.$nextTick()
                .then(() => {

                    this.setLoading()

                    this.repositories.fechamento.getEquipes(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {

                            this.data.form.equipes = Object.assign(response.data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })

            this.$nextTick()
                .then(() => {
                    this.loaded = true
                    this.$refs.RkmModal.show()
                })
        },
        save() {

            if (this.atendimentoIndividual && this.data.model.criaFichaAtendimentoIndividual) {

                this.$refs.Tabs.atendimentoIndividual()
                    .then(result => {

                        if (result) {

                            if (this.tipo == 'agendamento') {

                                const atendimentoIndividual = this.dadosAtendimentoIndividual

                                this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                    .atendimentoIndividual = atendimentoIndividual;

                                const consultas = this.clone(this.consultas)

                                const agendamento = consultas
                                    .find(consulta => consulta.agendamentoId === this.id);

                                const procedimentos = agendamento.procedimentos.filter(procedimento =>
                                    procedimento.usuarioId == atendimentoIndividual.cadastro.usuario.id
                                    && procedimento.origem !== 'atencaoBasica'
                                );

                                this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                    .procedimentos = procedimentos;

                                atendimentoIndividual.procedimentos.forEach(procedimentoAtencaoBasica => {

                                    const existe = procedimentos
                                        .find(procedimento => procedimento.id == procedimentoAtencaoBasica.id
                                            && procedimentoAtencaoBasica.usuarioId == atendimentoIndividual.cadastro.usuario.id,
                                        )

                                    const existePadrao = agendamento.procedimento
                                        && agendamento.procedimento.id == procedimentoAtencaoBasica.id;

                                    if (!existe && !existePadrao) {

                                        const equipe = this.data.form.equipes
                                            .find(e => e.id === atendimentoIndividual.cadastro.equipeId).descricao

                                        const param = {
                                            id: procedimentoAtencaoBasica.id,
                                            nome: procedimentoAtencaoBasica.nome,
                                            codigo: procedimentoAtencaoBasica.codigo,
                                            usuario: atendimentoIndividual.cadastro.usuario,
                                            usuarioId: atendimentoIndividual.cadastro.usuario.id,
                                            equipeId: atendimentoIndividual.cadastro.equipeId,
                                            ocupacaoId: atendimentoIndividual.cadastro.ocupacaoId,
                                            equipe: equipe,
                                            ocupacao: this.data.model.ocupacao,
                                            origem: procedimentoAtencaoBasica.origem,
                                            padrao: false,
                                            automatico: false,
                                            cid: null,
                                            quantidade: 1,
                                            quantidadeMaximaExecucao: procedimentoAtencaoBasica.quantidadeMaximaExecucao
                                        }

                                        this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                            .procedimentos.push(param)
                                    }
                                })

                                this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                    .temAtendimentoIndividual = true;
                            } else {

                                const atendimentoIndividual = this.dadosAtendimentoIndividual

                                this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                    .atendimentoIndividual = atendimentoIndividual;

                                const atendimento = this.consultas
                                    .find(consulta => consulta.atendimentoId === this.id);

                                const procedimentos = atendimento.procedimentos.filter(procedimento =>
                                    procedimento.usuarioId == atendimentoIndividual.cadastro.usuario.id
                                    && procedimento.origem !== 'atencaoBasica'
                                );

                                atendimentoIndividual.procedimentos.forEach(procedimentoAtencaoBasica => {

                                    const existe = procedimentos
                                        .find(procedimento => procedimento.id == procedimentoAtencaoBasica.id
                                            && procedimentoAtencaoBasica.usuarioId == atendimentoIndividual.cadastro.usuario.id,
                                        )

                                    const existePadrao = atendimento.procedimento
                                        && atendimento.procedimento.id == procedimentoAtencaoBasica.id;

                                    if (!existe && !existePadrao) {

                                        const equipe = this.data.form.equipes
                                            .find(e => e.id === atendimentoIndividual.cadastro.equipeId).descricao

                                        const param = {
                                            id: procedimentoAtencaoBasica.id,
                                            nome: procedimentoAtencaoBasica.nome,
                                            codigo: procedimentoAtencaoBasica.codigo,
                                            usuario: atendimentoIndividual.cadastro.usuario,
                                            usuarioId: atendimentoIndividual.cadastro.usuario.id,
                                            equipeId: atendimentoIndividual.cadastro.equipeId,
                                            ocupacaoId: atendimentoIndividual.cadastro.ocupacaoId,
                                            equipe: equipe,
                                            ocupacao: this.data.model.ocupacao,
                                            origem: procedimentoAtencaoBasica.origem,
                                            padrao: false,
                                            automatico: false,
                                            cid: null,
                                            quantidade: 1,
                                            quantidadeMaximaExecucao: procedimentoAtencaoBasica.quantidadeMaximaExecucao
                                        }

                                        this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                            .procedimentos.push(param)
                                    }
                                })

                                this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                    .temAtendimentoIndividual = true;
                            }

                            this.$refs.RkmModal.hide()
                        }
                    });
            }

            if (this.atendimentoOdontologico && this.data.model.criaFichaAtendimentoOdontologico) {

                this.$refs.Tabs.atendimentoOdontologico()
                    .then(result => {

                        if (result) {

                            if (this.tipo == 'agendamento') {

                                const atendimentoOdontologico = this.dadosAtendimentoOdontologico

                                this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                    .atendimentoOdontologico = atendimentoOdontologico;

                                const agendamento = this.consultas
                                    .find(consulta => consulta.agendamentoId === this.id);

                                const procedimentos = agendamento.procedimentos.filter(procedimento =>
                                    procedimento.usuarioId !== atendimentoOdontologico.cadastro.usuario.id
                                    && procedimento.origem !== 'atencaoBasica'
                                );

                                this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                    .procedimentos = procedimentos;

                                atendimentoOdontologico.procedimentos
                                    .forEach(procedimentoAtencaoBasica => {

                                        const existe = procedimentos.find(procedimento =>
                                            procedimento.id == procedimentoAtencaoBasica.id
                                            && procedimentoAtencaoBasica.usuarioId == atendimentoOdontologico.cadastro.usuario.id,
                                        )

                                        if (!existe) {

                                            const equipe = this.data.form.equipes
                                                .find(e => e.id === atendimentoOdontologico.cadastro.equipeId).descricao

                                            const param = {
                                                id: procedimentoAtencaoBasica.id,
                                                nome: procedimentoAtencaoBasica.nome,
                                                codigo: procedimentoAtencaoBasica.codigo,
                                                usuario: atendimentoOdontologico.cadastro.usuario,
                                                usuarioId: atendimentoOdontologico.cadastro.usuario.id,
                                                equipeId: atendimentoOdontologico.cadastro.equipeId,
                                                ocupacaoId: atendimentoOdontologico.cadastro.ocupacaoId,
                                                equipe: equipe,
                                                ocupacao: this.data.model.ocupacao,
                                                origem: procedimentoAtencaoBasica.origem,
                                                quantidade: procedimentoAtencaoBasica.quantidade,
                                                padrao: false,
                                            }

                                            this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                                .procedimentos.push(param)
                                        }
                                })

                                this.consultas.find(consulta => consulta.agendamentoId == this.id)
                                    .temAtendimentoOdontologico = true;
                            } else {

                                const atendimentoOdontologico = this.dadosAtendimentoOdontologico

                                this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                    .atendimentoOdontologico = atendimentoOdontologico;

                                const atendimento = this.consultas
                                    .find(consulta => consulta.atendimentoId === this.id);

                                const procedimentos = atendimento.procedimentos.filter(procedimento =>
                                    procedimento.usuarioId !== atendimentoOdontologico.cadastro.usuario.id
                                    && procedimento.origem !== 'atencaoBasica'
                                );

                                this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                    .procedimentos = procedimentos;

                                atendimentoOdontologico.procedimentos
                                    .forEach(procedimentoAtencaoBasica => {

                                        const existe = procedimentos.find(procedimento =>
                                            procedimento.id == procedimentoAtencaoBasica.id
                                            && procedimentoAtencaoBasica.usuarioId == atendimentoOdontologico.cadastro.usuario.id,
                                        )

                                        if (!existe) {

                                            const equipe = this.data.form.equipes
                                                .find(e => e.id === atendimentoOdontologico.cadastro.equipeId).descricao

                                            const param = {
                                                id: procedimentoAtencaoBasica.id,
                                                nome: procedimentoAtencaoBasica.nome,
                                                codigo: procedimentoAtencaoBasica.codigo,
                                                usuario: atendimentoOdontologico.cadastro.usuario,
                                                usuarioId: atendimentoOdontologico.cadastro.usuario.id,
                                                equipeId: atendimentoOdontologico.cadastro.equipeId,
                                                ocupacaoId: atendimentoOdontologico.cadastro.ocupacaoId,
                                                equipe: equipe,
                                                ocupacao: this.data.model.ocupacao,
                                                origem: procedimentoAtencaoBasica.origem,
                                                quantidade: procedimentoAtencaoBasica.quantidade,
                                                padrao: false,
                                            }

                                            this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                                .procedimentos.push(param)
                                        }
                                })

                                this.consultas.find(consulta => consulta.atendimentoId == this.id)
                                    .temAtendimentoOdontologico = true;
                            }

                            this.$refs.RkmModal.hide()
                        }
                    })
            }
        },
        handleAtendimentoIndividual(value) {

            this.atendimentoIndividual = value
        },
        saveAtendimentoIndividual(value) {

            this.dadosAtendimentoIndividual = value
        },
        handleAtendimentoOdontologico(value) {

            this.atendimentoOdontologico = value
        },
        saveAtendimentoOdontologico(value) {

            this.dadosAtendimentoOdontologico = value
        },
    },
    mixins: [error, repository, stringCase, object],
    props: {
        consultas: { type: Array, required: true },
    },
}
</script>